import { z } from "zod";
import type { PermissionKey } from "./permissions";

/**
 * As planilhas que saem pelo "Exportar" e a permissão de cada uma. O servidor confere essa
 * permissão antes do arquivo existir — esconder o botão sozinho não segura nada.
 *
 * Pacientes não passa pelo registro genérico: tem endpoint próprio (`patient.exportar`), que entrega
 * só os campos marcados. Está aqui pelo rótulo do Registro de exportações.
 */
export const PLANILHAS = {
  pacientes: { rotulo: "Planilha de pacientes", permissao: "patients.export" },
  pedidos: { rotulo: "Planilha de pedidos", permissao: "production.export" },
  producao: { rotulo: "Planilha de produção", permissao: "production.export" },
  lancamentos: { rotulo: "Planilha de lançamentos", permissao: "finance.view" },
  extrato: { rotulo: "Planilha de extrato", permissao: "finance.view" },
  "visao-financeira": { rotulo: "Tabela do financeiro", permissao: "finance.view" },
  cadastros: { rotulo: "Planilha de cadastros", permissao: "partners.manage" },
  equipe: { rotulo: "Planilha da equipe", permissao: "team.manage" },
} as const satisfies Record<string, { rotulo: string; permissao: PermissionKey }>;

export type Planilha = keyof typeof PLANILHAS;

const PLANILHAS_DO_REGISTRO = ["pedidos", "producao", "lancamentos", "extrato", "visao-financeira", "cadastros", "equipe"] as const;
export type PlanilhaDoRegistro = (typeof PLANILHAS_DO_REGISTRO)[number];

export const planilhaRegistrarSchema = z.object({
  planilha: z.enum(PLANILHAS_DO_REGISTRO),
  linhas: z.number().int().min(0).max(1_000_000),
  colunas: z.array(z.string().trim().min(1).max(80)).min(1).max(60),
});
export type PlanilhaRegistrarInput = z.infer<typeof planilhaRegistrarSchema>;

/** O nome legível de uma linha EXPORT da auditoria, pro Registro de exportações. */
export function rotuloDaExportacao(resource: string, details: string | null): string {
  if (resource.startsWith("planilha.")) {
    return PLANILHAS[resource.slice("planilha.".length) as Planilha]?.rotulo ?? "Planilha";
  }
  if (resource === "patient.list") return "Planilha de pacientes";
  if (resource === "organization") return details === "exportação baixada" ? "Exportação completa baixada" : "Exportação completa pedida";
  if (resource === "anamnese") return "Impressão de anamnese";
  if (resource === "plano") return "Impressão de orçamento";
  return "Exportação";
}
